<script setup lang="ts">
import { getElementUiObject, getCard } from '@mop/cms/utils/utils';
import type { CmsUiDoubleCard } from './uiCmsCard';

defineOptions({
  name: 'UiCmsDoubleCard',
});

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  lazyLoad: {
    type: Boolean,
    default: false,
  },
});

const data = props.data;

const imageType = 'cms-two-column-no-ratio';
const element: CmsUiDoubleCard = getElementUiObject(data, {
  left: getCard(data.cards?.[0]),
  right: getCard(data.cards?.[1]),
  hasIndentation: data.hasIndentation,
});
if (element.left) {
  element.left.imageType = imageType;
  element.left.headline.level ??= 3;
}
if (element.right) {
  element.right.imageType = imageType;
  element.right.headline.level ??= 3;
}
</script>

<template>
  <div
    v-if="element.left && element.right"
    v-storyblok-editable="element"
    :class="[
      'ui-cms-double-card',
      {
        'ui-cms-double-card--has-indentation': element.hasIndentation,
      },
    ]"
  >
    <div class="ui-cms-double-card__item">
      <UiCmsCardItem
        :data="element.left"
        :lazy-load="lazyLoad"
        :data-track-element-item="`${element.left.media?.trackingId}|1`"
      />
    </div>
    <div class="ui-cms-double-card__item">
      <UiCmsCardItem
        :data="element.right"
        :lazy-load="lazyLoad"
        :data-track-element-item="`${element.right.media?.trackingId}|2`"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-cms-double-card {
  display: flex;
  flex-wrap: wrap;
}

.ui-cms-double-card--has-indentation {
  padding: 0 $ui-global-padding;
}

.ui-cms-double-card__item {
  flex-basis: 50%;
  width: 50%;

  @include apply-upto(small) {
    flex-basis: 100%;
    width: 100%;
  }
}
</style>
